import { Narrowphase } from "p2";

export default class CustomNarrowphase extends Narrowphase {}
